import * as React from 'react';
import {useTheme} from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import {Grid, Stack} from '@mui/material';
import {Box} from '@mui/material';
import {BarChart, ChartsLabelMark, legendClasses, LineChart, useDrawingArea, useYScale} from '@mui/x-charts';
import {Unstable_RadarChart as RadarChart} from '@mui/x-charts/RadarChart';
import {areaElementClasses, lineElementClasses} from "@mui/x-charts/LineChart";
import {green, red} from '@mui/material/colors';
import {ScaleLinear} from 'd3-scale';
import {gray} from "@/theme/themePrimitives";
import {XYVO} from "@/service/analyze";
import {transformMoney} from "@/helper/method";

const uData = [1300, 3000, 2000, 2780, 1890, 2390, 3490];
const xLabels = [
    'Page A',
    'Page B',
    'Page C',
    'Page D',
    'Page E',
    'Page F',
    'Page G',
];

function ColorPalette({id}: { id: string }) {
    return (
        <defs>
            <linearGradient
                id={id}
                x1="50%" y1="0%" x2="50%"
                y2={`100%`}
                gradientUnits="userSpaceOnUse" // Use the SVG coordinate instead of the component ones.
            >
                <stop offset="0%" stopColor={'#FFBBBB'} stopOpacity={1}/>
                <stop offset="100%" stopColor={'#A9F1DF'} stopOpacity={0.5}/>
            </linearGradient>
        </defs>
    );
}

export interface InvoiceMoneyTrendProps {
    recent1YearMoney: XYVO[]
    loading: boolean
}

export default function InvoiceMoneyTrend({recent1YearMoney, loading}: InvoiceMoneyTrendProps) {
    return (
        <Card variant="outlined" sx={{width: '100%'}}>
            <CardContent>
                <Stack alignContent={'start'} alignItems={'start'} direction={'row'} justifyContent={'space-between'}>
                    <Typography component="h2" variant="subtitle2" gutterBottom>
                        近一年开票金额趋势
                    </Typography>
                    <Stack alignItems={'start'} direction={'row'} spacing={2}>
                        单位 (万元)
                    </Stack>
                </Stack>
                <LineChart
                    height={180}
                    loading={loading}
                    localeText={{loading: "加载中"}}
                    series={[
                        {
                            data: recent1YearMoney?.map(item => item.y) || [],
                            valueFormatter: (value) => `${value! / 10000}万`,
                            label: '金额',
                            id: 'invoiceMoney',
                            area: true,
                            showMark: false
                        },
                    ]}
                    hideLegend={true}
                    sx={{
                        [`& .${lineElementClasses.root}`]: {
                            stroke: '#FFBBBB',
                            strokeWidth: 2
                        },
                        [`& .${areaElementClasses.root}`]: {
                            fill: 'url(#invoiceMoney)',
                            filter: 'none', // Remove the default filter.
                        },
                    }}
                    xAxis={[{scaleType: 'point', disableTicks: true, data: recent1YearMoney?.map(item => item.x) || []}]}
                    yAxis={[{width: 34, disableTicks: true, valueFormatter: (value: number) => transformMoney(value), disableLine: true}]}
                    margin={{left: 0, right: 0, top: 10, bottom: 0}}
                >
                    <ColorPalette id="invoiceMoney"/>
                </LineChart>
            </CardContent>
        </Card>
    );
}
